import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { HeroHeader } from "../components/typography";
import { Colors } from "../components/styles/Colors";

const Wrapper = styled.div`
  position: relative;

  .gatsby-image-wrapper {
    min-height: 350px;
  }

  ${HeroHeader} {
    color: ${Colors.white};

    position: absolute;
    bottom: 25px;
    left: 50%;

    width: 100%;
    text-align: center;

    transform: translateX(-50%);
  }
`;

export default function BGImageHero({ image, text }) {
  return (
    <Wrapper>
      <Image fluid={image} />
      <HeroHeader>{text}</HeroHeader>
    </Wrapper>
  );
}
